import { Component, HostListener, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-scroll-to-top',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  template: `
    <button
      mat-mini-fab
      color="primary"
      class="scroll-to-top"
      [@fadeInOut]="isVisible ? 'visible' : 'hidden'"
      (click)="scrollToTop()"
      *ngIf="isVisible"
      aria-label="Scroll to top">
      <mat-icon>keyboard_arrow_up</mat-icon>
    </button>
  `,
  styles: [`
    .scroll-to-top {
      position: fixed;
      bottom: 16px;
      right: 16px;
      z-index: 1000;
      opacity: 0.8;
      transition: opacity 0.2s ease;

      &:hover {
        opacity: 1;
      }
    }

    // @media (max-width: 480px) {
    //   .scroll-to-top {
    //     bottom: 16px;
    //     right: 16px;
    //   }
    // }
  `],
  animations: [
    trigger('fadeInOut', [
      transition('hidden => visible', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition('visible => hidden', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(20px)' }))
      ])
    ])
  ]
})
export class ScrollToTopComponent implements OnInit {
  isVisible = false;
  private scrollThreshold = 400;

  private windowAvailable = typeof window !== 'undefined';

  @Input() topPosition = 0;

  ngOnInit() {
    this.checkScroll();
  }

  @HostListener('window:scroll')
  checkScroll() {
    this.windowAvailable && (this.isVisible = window.scrollY > this.scrollThreshold);
  }

  scrollToTop() {
    this.windowAvailable && window.scrollTo({ top: this.topPosition, behavior: 'smooth' });
  }
}
